import { IRichMarkdownRef, RichMarkdownEditor } from "lucy/common-components";
import * as React from "react";
import { useState } from "react";
import { ISerializedUIField, IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import { FieldContainer } from "../../../common/FieldContainer";
import MarkdownView from "../../../common/Markdown/MarkdownView";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { DataSourceProperty } from "../../../common/ui-props/DataSourceProperty";
import { DropdownProperty } from "../../../common/ui-props/DropdownProperty";
import { RichTextProperty } from "../../../common/ui-props/RichTextProperty";
import { createDefaultPropsForWidgetWrapperWithSidebar, WidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";
import './resource-booking.scss'
import { MultipleImagesProperty } from "../../../common/ui-props/MultitpleImagesProperty";
import { Button, DatePicker, WidgetWrapper, useEffectWithPolling } from "uxp/components";
import { SimpleNumberProperty } from "../../../common/ui-props/SimpleNumberProperty";
import { executeAndBind } from "../../../common/data-source-picker/datasource";
import { ButtonProperty, extractButtonProperties } from "../../../common/ui-props/ButtonProperty";
import ActionButton from "../../../common/components/ActionButton";
import { generateIconPropAsSting } from "../../../common/icon-selector/IconEditor";
import { SimpleDateProperty } from "../../../common/ui-props/SimpleDateProperty";
import { SimpleColorProperty } from "../../../common/ui-props/ColorProperty";
import { DefaultAction, IAction } from "../../../common/action-editor/ActionEditor";
import _ from "lodash";
import { BooleanProperty } from "../../../common/ui-props/BooleanProperty";
import { TextProperty, extractTextProperties } from "../../../common/ui-props/TextProperty";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import { extractContextData, loadInitialData, replaceWithData } from "../../../../util";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";

const DEFAULT_DESCRIPTION = `### Meeting Room 1\n\nA brief description of this meeting room can go here along with some more information about it`

const DefaultActionData: IAction = {
    type: 'execute-action',
    lucyAction: {
        modelName: 'ResourceBooking',
        action: 'NewBooking',
        params: {},
        dialogTitle: 'Book this time slot',
        executionMsg: 'Booking this time slot...',
        postExecution: {
            success: {
                msg: 'Booking successful',
                goToHome: false,
                buttonTitle: 'Done',
                action: { ..._.cloneDeep(DefaultAction) },
                reloadWidget: true
            },
            error: {
                msg: 'Booking failed',
                goToHome: false,
                buttonTitle: 'Close',
                action: { ..._.cloneDeep(DefaultAction) },
                reloadWidget: true
            }
        }
    }
}


const defaultUIProps = {
    title: { text: 'Room Booking', color: '#000000', size: '19px' },
    body: {
        background: {
            color: '',
            image: {
                image: "",
                position: "",
                size: "",
            },
        },
        removeShadow: false,
    },
    selectTimeSlotTextColor: "#000000",
    timeSlotDuration: "60",
    refreshInterval: 6000,
    dateChooseTextColor: "#000000",
    defaultDate: new Date(),
    disableDatePicker: false,
    bookingButton: {
        label: 'Book!',
        onClick: DefaultActionData,
        color: '',
        backgroundColor: '',
        icon: {
            icon: '',
            position: 'left',
            color: '',
            size: '12px'
        },
    },
    description: DEFAULT_DESCRIPTION,
    descriptionColor: "#000000",
    imageGallery: [] as string[],
    selectedBoxColor: "#013D3F",
    selectedBoxTextColor: "#000000",
    alreadyBookedBoxColor: "#D1FDFF",
    alreadyBookedBoxTextColor: "#424242",
    freeBoxColor: "#72C1C7",
    freeBoxTextColor:"#424242",
};


const XPR: React.FunctionComponent<IWidgetTemplateProps> = (props) => {
    const [selectedTimeSlot, setSelectedTimeSlot] = React.useState<Date>(null)
    const [selectedDate, setSelectedDate] = React.useState<Date>(null)

    let uiProps = props.uiProps || {};

    console.log("uiProps", { ...defaultUIProps, ...props.uiProps });

    const XPRProps = {
        'title': TextProperty(defaultUIProps.title, 'Room Booking'),
        'body': ContainerProperty(defaultUIProps.body, 'Background'),

        // 'initialDataSource': DataSourceProperty('Initial Data Source', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary-array'),
        'timeSlotDuration': DropdownProperty("Time slot duration", defaultUIProps.timeSlotDuration, {
            showCategoryTitle: true,
            data: [
                { id: "360", name: "6 Hour" },
                { id: "180", name: "3 Hour" },
                { id: "150", name: "2.5 Hour" },
                { id: "120", name: "2 Hour" },
                { id: "90", name: "1.5 Hour" },
                { id: "60", name: "1 Hour" },
                { id: "30", name: "30 Minutes" },
            ],
            selected: "60"
        }),
        'refreshInterval': SimpleNumberProperty('Refresh Time', defaultUIProps.refreshInterval),
        'defaultDate': SimpleDateProperty('Default booking date', defaultUIProps.defaultDate, false),
        'disableDatePicker': BooleanProperty('Disable date picker to choose the date', defaultUIProps.disableDatePicker),
        'dateChooseTextColor': SimpleColorProperty('Label Color', '#000000'),
        'descriptionColor': SimpleColorProperty('Content Color', '#000000'),
        'timeSlotsDataSource': DataSourceProperty('Get booked time slots', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary-array'),
        'bookingButton': ButtonProperty(defaultUIProps.bookingButton as any),
        'description': RichTextProperty("Content", defaultUIProps.description),
        'selectTimeSlotTextColor': SimpleColorProperty('Text Color', '#000000'),
        'imageGallery': MultipleImagesProperty("Gallery", defaultUIProps.imageGallery),
        'selectedBoxColor': SimpleColorProperty("Selected box color", defaultUIProps.selectedBoxColor),
        'selectedBoxTextColor': SimpleColorProperty("Selected box text color", defaultUIProps.selectedBoxTextColor),
        'alreadyBookedBoxColor': SimpleColorProperty("Already booked box color", defaultUIProps.alreadyBookedBoxColor),
        'alreadyBookedBoxTextColor': SimpleColorProperty("Already booked box text color", defaultUIProps.alreadyBookedBoxTextColor),
        'freeBoxColor': SimpleColorProperty("Free box color", defaultUIProps.freeBoxColor),
        'freeBoxTextColor': SimpleColorProperty("Free box text color", defaultUIProps.freeBoxTextColor),

    };

    let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title || defaultUIProps.title, 'Room Booking');
    const { styles: bodyStyles } = extractContainerProperties(uiProps.body || defaultUIProps.body);


    let { label, onClick, icon: buttonIcon, iconPosition, iconStyles: buttonIconStyles, buttonStyles } = extractButtonProperties(uiProps.bookingButton, 'Book!')

    let date = uiProps.defaultDate ? new Date(uiProps.defaultDate || defaultUIProps.defaultDate) : new Date()
    if (selectedDate) date = selectedDate;

    const disableDatePicker = !!uiProps?.disableDatePicker;

    date.setMilliseconds(0)
    date.setSeconds(0)
    date.setMinutes(0)
    date.setHours(0)

    const selectedBoxColor = uiProps.selectedBoxColor || defaultUIProps.selectedBoxColor
    const alreadyBookedBoxColor = uiProps.alreadyBookedBoxColor || defaultUIProps.alreadyBookedBoxColor
    const freeBoxColor = uiProps.freeBoxColor || defaultUIProps.freeBoxColor

    const selectedBoxTextColor = uiProps.selectedBoxTextColor || defaultUIProps.selectedBoxTextColor;
    const alreadyBookedBoxTextColor = uiProps.alreadyBookedBoxTextColor || defaultUIProps.alreadyBookedBoxTextColor;
    const freeBoxTextColor = uiProps.freeBoxTextColor || defaultUIProps.freeBoxTextColor;

    const [disableDrop, setDisableDrop] = useState(false);

    interface IActionResponse {
        time: Date,
        available: boolean
    }
    const [bookedTimeSlots, setBookedTimeSlots] = useState<IActionResponse[]>(null);

    const descriptionEditorRef = React.useRef<IRichMarkdownRef>(null);
    const containerRef = React.useRef(null);

    let isDesignMode = props.designer?.mode == 'thumbnail' || props.designer?.mode == "preview";

    let [contextData, setContextData] = React.useState<IContextData>({})
    const [loading, setLoading] = React.useState(false)
    
    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    
    title = replaceWithData(title, contextData)
    
    React.useEffect(() => {
        updateHeight()
    }, [props.uiProps])

    const timeSlotDuration = Number(uiProps.timeSlotDuration || '60')
    let refreshInsterval = Number(uiProps?.refreshInterval) || defaultUIProps.refreshInterval;

    useEffectWithPolling(props.uxpContext, "timeslots/1", refreshInsterval || 6000, async () => {
        if (isDesignMode) {
            // Make the third and fifth time slots booked
            const time = new Date(date)
            const bookedTimes = [
                new Date(time.setTime(time.getTime() + 3 * Number(timeSlotDuration) * 60 * 1000)),
                new Date(time.setTime(time.getTime() + 2 * Number(timeSlotDuration) * 60 * 1000))
            ]

            setBookedTimeSlots(
                bookedTimes.map((t) => ({
                    time: t,
                    available: false
                }))
            )

            return;
        }

        const parameters = {
            'start': date.toISOString(),
            'end': new Date(date.getTime() + 3600 * 24 * 1000).toISOString(),
            'increment': timeSlotDuration,
        }

        executeAndBind(props.uxpContext, uiProps.timeSlotsDataSource, uiProps.datasources, parameters,contextData, {
            disableParseParameters: true
        })
            .then(data => {
                setBookedTimeSlots(data?.map((t: any) => ({
                    time: new Date(t?.time),
                    available: !!t?.available
                })))
            })
    }, [props.designer]);

    function updateHeight() {
        const container = containerRef.current as HTMLDivElement
        if (container) {
            if (props.updateWidgetHeight) {
                props.updateWidgetHeight(container.scrollHeight)
            }
        }
    }

    const isTimeSlotBooked = (startTime: Date) => {
        return !!bookedTimeSlots?.filter((b) => !b.available)
            ?.find((t) => t?.time?.getTime() == startTime?.getTime())
    }

    const renderTimeslots = () => {
        let time = new Date(date)
        time.setMilliseconds(0);
        time.setSeconds(0);
        time.setMinutes(0);
        time.setHours(0);

        let nextDate = new Date(time.getTime())
        nextDate.setDate(nextDate.getDate() + 1);

        const timeslots = []

        do {
            let timeSlot = new Date(time.getTime());
            const hours = timeSlot?.getHours();
            const minutes = timeSlot?.getMinutes();

            let isSelected = (selectedTimeSlot?.getHours() == hours && selectedTimeSlot?.getMinutes() == minutes)
            let isBooked = isTimeSlotBooked(timeSlot)

            timeslots.push(
                <div
                    className={`rb-time-slot ${isBooked ? 'booked' : ''} ${isSelected ? 'selected' : ''}`}
                    onClick={() => !isDesignMode && !isBooked && setSelectedTimeSlot(timeSlot)}
                    style={{
                        backgroundColor: isBooked ? alreadyBookedBoxColor : (isSelected ? selectedBoxColor : freeBoxColor),
                        color: isBooked ? alreadyBookedBoxTextColor : (isSelected ? selectedBoxTextColor : freeBoxTextColor)
                    }}
                >
                    {`${hours}:${String(minutes).padStart(2, '0')}`}
                </div>
            )

            time.setTime(timeSlot.getTime() + Number(timeSlotDuration) * 60 * 1000)
        } while (nextDate.getDate() != time.getDate());

        return (
            <div className='rb-time-slots'>
                {timeslots}
            </div>
        )
    }

    const gallery: string[] = uiProps.imageGallery || []; // image urls
    const renderImageGallery = () => {
        const galleryElements = gallery.map((g) => (
            <div
                className={`rb-gallery-item ${!g ? 'rb-gallery-dummy' : ''}`}
                style={{
                    backgroundImage: `url('${g}')`,
                    backgroundSize: 'cover',
                }}
            />
        ));

        if (isDesignMode && !galleryElements.length) {
            galleryElements.push(<div className='rb-gallery-item rb-gallery-dummy' />)
            galleryElements.push(<div className='rb-gallery-item rb-gallery-dummy' />)
        }

        return (
            <div className='rb-gallery'>
                {galleryElements}
            </div>
        )
    }


    let start = new Date(selectedTimeSlot)
    let end = new Date(selectedTimeSlot?.getTime() + Number(timeSlotDuration) * 60 * 1000)

    const params = {
        start,
        end,
        ...contextData?.form,
        fields: { ...contextData?.form }
    }

    return (<WidgetWrapper className="wd-widget-wrapper uxp-rb-template">
        <SelectableItem
            className='content'
            showAtRuntime={true}
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'body')}
            elementId={'body'}
            contextData={contextData}
        >
            <div className='container' ref={containerRef} style={bodyStyles}>
                <div className="header">
                    <SelectableItem
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'title')}
                        contextData={contextData}
                    >
                        <div className="uxp-widget-title-bar uxp-drag-handler">
                            <div className="title-section" style={titleStyles}>
                                <span className="title-icon"></span>
                                <span className="txt">{title}</span>
                            </div>
                        </div>
                    </SelectableItem>
                </div>

                <div className="body rb-body" >
                    <div className='rb-header'>
                        {
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'description', 'descriptionColor')}
                                contextData={contextData}
                           >
                                <div style={{ color: uiProps.descriptionColor || '#000000' }}>
                                    <MarkdownView text={uiProps?.description || DEFAULT_DESCRIPTION} />
                                </div>
                            </SelectableItem>
                        }
                    </div>
                    <div className="rb-gallery-container">
                        <SelectableItem
                            designer={props.designer}
                            props={selectUIProps(uiProps, XPRProps, 'imageGallery')}
                            contextData={contextData}
                        >
                            {renderImageGallery()}
                        </SelectableItem>
                    </div>
                    <div className='rb-custom'>
                        <SelectableItem
                            designer={props.designer}
                            props={selectUIProps(uiProps, XPRProps, 'roomDescription')}
                            contextData={contextData}
                        >
                            <FieldContainer
                                designer={props.designer}
                                uxpContext={props.uxpContext}
                                contextData={contextData}
                                onChangeData={setContextData}
                                uiProps={uiProps}
                                disabled={false}
                            />
                        </SelectableItem>
                    </div>
                    <div className="rb-datetime-container">

                        <div className='rb-datetime'>
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'defaultDate', 'disableDatePicker', 'dateChooseTextColor')}
                                contextData={contextData}
                            >
                                <div className="rb-instructions" style={{ color: uiProps.dateChooseTextColor || '#000000' }}>Choose a date</div>
                                <div className="rb-date-picker">
                                    {
                                        !disableDatePicker ?
                                            <DatePicker
                                                title={'Choose date'}
                                                date={date}
                                                onChange={setSelectedDate} /> :
                                            <div className='rb-date'>{(date || new Date()).toLocaleDateString()}</div>
                                    }
                                </div>

                            </SelectableItem>

                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'selectTimeSlotTextColor', 'timeSlotsDataSource', 'timeSlotDuration', 'refreshInterval', 'freeBoxColor','freeBoxTextColor', 'alreadyBookedBoxColor', 'alreadyBookedBoxTextColor',  'selectedBoxColor','selectedBoxTextColor')}
                                contextData={contextData}
                            >
                                <div className="rb-instructions" style={{ color: uiProps.selectTimeSlotTextColor || '#000000', marginTop: '20px' }}>Select a time slot</div>
                                {renderTimeslots()}
                            </SelectableItem>
                        </div>
                    </div>

                    <div className="submit-button-container">

                        <SelectableItem
                            designer={props.designer}
                            props={selectUIProps(uiProps, XPRProps, 'bookingButton')}
                            contextData={contextData}
                        >
                            <ActionButton
                                designer={props.designer}
                                uxpContext={props.uxpContext}
                                contextData={contextData}
                                title={label}
                                action={uiProps.bookingButton?.onClick ? onClick : DefaultActionData}
                                styles={buttonStyles}
                                icon={generateIconPropAsSting(buttonIcon)}
                                iconPosition={iconPosition}
                                iconStyles={buttonIconStyles}
                                onReloadWidget={() => { }}
                                customParams={params}
                            />
                        </SelectableItem>
                    </div>
                </div>
            </div>
        </SelectableItem>

    </WidgetWrapper>
    )
};

registerCardTemplate({
    id: 'resource-booking',
    name: 'Resource Booking',
    description: 'An interface to allow booking of resources like rooms, seats and services',
    template: XPR,
    canDragDropFields: true,
    icon: ['fas', 'credit-card-blank'],
    complexity: 'advanced',
    autoHieght: true,
});